import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ISocketSlice = {
  isConnected: boolean;
};

const initialState: ISocketSlice = {
  isConnected: false,
};

export const socketSlice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setIsConnected: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },
  },
});

export const socketAction = socketSlice.actions;

export default socketSlice.reducer;
